<template>
    <div v-html="field.etiqueta" :name="`process[${field.nombre}]`" class="my-4 text-center text-h6"></div>
</template>

<script>
    export default {
        name: "Subtitle",
        props: ['field', 'name']
    }
</script>

<style scoped>

</style>